import React from 'react';
import ActionApproveFunctional from './components/action-approve-functional';
import './action-approve.scss';

const ActionApprove =() =>{
    return(
       <ActionApproveFunctional/>
    )
}
export default ActionApprove;